module.exports = __webpack_public_path__ + "assets/failure-82eb82.svg";